
<th [ngClass]="createClass(header)" *ngFor="let header of headers">
  <span (click)="sortClick(header)">{{header.name |transloco}}</span>
  <div class="subheaders" style="display: block" *ngIf="header.subHeaders">
      <ng-container *ngIf="header.subHeaders">
          <ng-container *ngFor="let subheader of header.subHeaders; let i = index">
            <div [ngClass]="header.subHeadersClasses ? header.subHeadersClasses(header.name+'-'+subheader) : undefined" class="subheader" (click)="subHeaderClick(header.name+'-'+subheader)">{{ subheader }}</div>
          </ng-container>
        </ng-container>
  </div>
</th>
